var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(_vm.value)?_c('span',[_c('a',{attrs:{"href":_vm.numberLink}},[_vm._v(_vm._s(_vm.value))])]):_c('span',[_vm._v("N/A")])])}
var staticRenderFns = []

export { render, staticRenderFns }